import template from './AxSurveyFieldText.html';

function AxSurveyFieldText() {

  return {
    restrict: 'E',
    scope: {
      // We don't want long names :)
      axC: '=axControl', // Bi-directional binding - to można zapodawac do kązdej dyrektywy - definiuje jak są ich wartości bindowane
      li18n: '=axI18n'
    },
    link: link,
    template,
    controllerAs: 'vm',
    bindToController: true,
    controller: ['Helpers', controller]
  }
}

function controller(helpers) {

  var vm = this;
  helpers.initField(vm);
  helpers.endInitField(vm);
}

function link($scope, $element, $attrs, $ctrl) {
}

export { AxSurveyFieldText };
